import { Box, Button, Chip, Stack, Tooltip } from '@mui/material'
import React, { useEffect, useState } from 'react'
import Typography from '@mui/material/Typography'
import SearchIcon from '@mui/icons-material/Search'
import SendIcon from '@mui/icons-material/Send'
import BookmarkIcon from '@mui/icons-material/Bookmark'
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder'
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck'
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth'
import SchoolIcon from '@mui/icons-material/School'
import AccessTimeIcon from '@mui/icons-material/AccessTime'
import EventAvailableIcon from '@mui/icons-material/EventAvailable'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import { makeGetRequest, makePostRequest } from 'utils/api'
import moment from 'moment'
import { toast } from 'react-toastify'
import CreateTask from './CreateTask'
import CreateEvent from './CreateEvent'

// ── Design tokens (cohérents avec le thème sombre LIFE) ───────────────────────
const C = {
  panel: '#0c1e3a',
  card: '#102a4d',
  cardHover: '#143258',
  cardActive: '#16386b',
  border: '1px solid rgba(193,218,241,0.12)',
  borderActive: '1px solid #1b75d0',
  accent: 'linear-gradient(135deg,#1b75d0 0%,#196081 100%)',
  textHi: '#eaf2fb',
  textLo: '#93a7c4',
  chipBg: 'rgba(27,117,208,0.16)',
}

export default function Traning() {
  const [traninglist, setTraningList] = useState([])
  const [filterTraninglist, setFilterTraningList] = useState([])
  const [selectedTraning, setSelectedTraning] = useState(false)
  const [createTache, setCreateTache] = useState(false)
  const [createEvent, setCreateEvent] = useState(false)
  const [savedIds, setSavedIds] = useState([])

  useEffect(() => {
    getTraningList()
  }, [])

  const handleJob = async (traning, status) => {
    const payload = { id: traning.id, status: status }
    const res = await makePostRequest('/api/Professional/tranings-status/', payload, {}, true)
    if (res.status === 200) {
      if (status === 'Enregistrer') setSavedIds((prev) => [...new Set([...prev, traning.id])])
      toast(`${traning.title} — ${status} ✓`, {
        position: 'top-right',
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        theme: 'dark',
        pauseOnFocusLoss: false,
      })
    }
  }
  const getTraningList = async () => {
    const res = await makeGetRequest('/api/Professional/tranings/', {}, true)
    if (res.status === 200) {
      setTraningList(res.data)
      setFilterTraningList(res.data)
    }
  }
  const handleInputChange = (event) => {
    let query = event.target.value
    if (query !== '') {
      setFilterTraningList(
        traninglist.filter(
          (el) =>
            (el.title || '').toLowerCase().includes(query.toLowerCase()) ||
            (el.provider || '').toLowerCase().includes(query.toLowerCase()),
        ),
      )
    } else {
      setFilterTraningList(traninglist)
    }
  }
  const toggleModal = () => setCreateEvent(false)

  return (
    <>
      {createEvent && <CreateEvent toggleModal={toggleModal} title={selectedTraning.title} />}
      {createTache && <CreateTask setCreateTache={setCreateTache} title={selectedTraning.title} />}

      <Box display="flex" gap={2} sx={{ flexDirection: { xs: 'column', md: 'row' } }}>
        {/* ── Colonne liste ─────────────────────────────────────────────── */}
        <Box
          sx={{
            width: { xs: '100%', md: 400 },
            minWidth: { md: 400 },
            height: '82vh',
            display: 'flex',
            flexDirection: 'column',
            background: C.panel,
            border: C.border,
            borderRadius: 3,
            p: 2,
          }}
        >
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1.5}>
            <Typography sx={{ fontSize: 18, fontWeight: 700, color: C.textHi }}>
              Offres de formation
            </Typography>
            <Chip
              label={filterTraninglist.length}
              size="small"
              sx={{ background: C.chipBg, color: '#74b7fd', fontWeight: 700 }}
            />
          </Stack>

          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              background: '#0a1730',
              border: C.border,
              borderRadius: 2,
              px: 1.5,
              py: 0.5,
              mb: 2,
            }}
          >
            <SearchIcon sx={{ color: C.textLo, fontSize: 20 }} />
            <input
              onChange={handleInputChange}
              placeholder="Rechercher une formation, un organisme…"
              style={{
                width: '100%',
                background: 'transparent',
                border: 'none',
                outline: 'none',
                color: C.textHi,
                fontSize: 14,
                padding: '8px 0',
              }}
            />
          </Box>

          <Box sx={{ overflowY: 'auto', flex: 1, pr: 0.5 }}>
            {filterTraninglist.length > 0 ? (
              <Stack spacing={1.25}>
                {filterTraninglist.map((traning, index) => {
                  const active = selectedTraning && selectedTraning.id === traning.id
                  const saved = savedIds.includes(traning.id)
                  return (
                    <Box
                      key={index}
                      onClick={() => setSelectedTraning(traning)}
                      sx={{
                        cursor: 'pointer',
                        background: active ? C.cardActive : C.card,
                        border: active ? C.borderActive : C.border,
                        borderRadius: 2.5,
                        p: 1.5,
                        transition: 'all .15s ease',
                        '&:hover': { background: C.cardHover, transform: 'translateY(-1px)' },
                      }}
                    >
                      <Stack direction="row" spacing={1.5}>
                        <Box
                          sx={{
                            width: 44,
                            height: 44,
                            borderRadius: 2,
                            background: C.accent,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            flexShrink: 0,
                          }}
                        >
                          <SchoolIcon sx={{ color: 'white' }} />
                        </Box>
                        <Box sx={{ minWidth: 0, flex: 1 }}>
                          <Typography
                            sx={{
                              fontSize: 15,
                              fontWeight: 700,
                              color: C.textHi,
                              lineHeight: 1.25,
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                            }}
                          >
                            {traning.title}
                          </Typography>
                          <Typography sx={{ fontSize: 13, color: '#c1daf1' }}>
                            {traning.provider}
                          </Typography>
                          {traning.duration && (
                            <Stack direction="row" alignItems="center" spacing={0.5} mt={0.25}>
                              <AccessTimeIcon sx={{ fontSize: 13, color: C.textLo }} />
                              <Typography sx={{ fontSize: 12, color: C.textLo }}>
                                {traning.duration}
                              </Typography>
                            </Stack>
                          )}
                          <Typography sx={{ fontSize: 11, color: C.textLo, mt: 0.5 }}>
                            {moment(traning.created_at).fromNow()}
                          </Typography>
                        </Box>
                        <Tooltip title="Enregistrer">
                          <Box
                            onClick={(e) => {
                              e.stopPropagation()
                              handleJob(traning, 'Enregistrer')
                            }}
                            sx={{ color: saved ? '#e5aa20' : C.textLo, '&:hover': { color: '#e5aa20' } }}
                          >
                            {saved ? <BookmarkIcon /> : <BookmarkBorderIcon />}
                          </Box>
                        </Tooltip>
                      </Stack>
                    </Box>
                  )
                })}
              </Stack>
            ) : (
              <Stack alignItems="center" justifyContent="center" spacing={1} sx={{ height: '100%', color: C.textLo }}>
                <SchoolIcon sx={{ fontSize: 48, opacity: 0.5 }} />
                <Typography sx={{ textAlign: 'center', fontSize: 14 }}>
                  Aucune formation trouvée…
                </Typography>
              </Stack>
            )}
          </Box>
        </Box>

        {/* ── Colonne détail ────────────────────────────────────────────── */}
        <Box
          sx={{
            flex: 1,
            height: '82vh',
            overflowY: 'auto',
            background: C.panel,
            border: C.border,
            borderRadius: 3,
            p: { xs: 2, md: 3 },
          }}
        >
          {selectedTraning ? (
            <Box>
              <Stack direction="row" spacing={2} alignItems="center">
                <Box
                  sx={{
                    width: 64,
                    height: 64,
                    borderRadius: 3,
                    background: C.accent,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0,
                  }}
                >
                  <SchoolIcon sx={{ color: 'white', fontSize: 32 }} />
                </Box>
                <Box>
                  <Typography sx={{ fontSize: 14, color: '#c1daf1', fontWeight: 600 }}>
                    {selectedTraning.provider}
                  </Typography>
                  <Typography sx={{ fontSize: 26, fontWeight: 800, color: C.textHi, lineHeight: 1.2 }}>
                    {selectedTraning.title}
                  </Typography>
                </Box>
              </Stack>

              <Stack direction="row" flexWrap="wrap" gap={1} mt={2}>
                {selectedTraning.duration && (
                  <Chip
                    icon={<AccessTimeIcon sx={{ color: '#74b7fd !important' }} />}
                    label={selectedTraning.duration}
                    sx={{ background: C.chipBg, color: C.textHi }}
                  />
                )}
                {selectedTraning.city && (
                  <Chip
                    icon={<EventAvailableIcon sx={{ color: '#74b7fd !important' }} />}
                    label={selectedTraning.city}
                    sx={{ background: C.chipBg, color: C.textHi }}
                  />
                )}
                {selectedTraning.start_date && (
                  <Chip
                    label={`Début : ${moment(selectedTraning.start_date).format('DD MMM YYYY')}`}
                    sx={{ background: C.chipBg, color: C.textHi }}
                  />
                )}
                {selectedTraning.end_date && (
                  <Chip
                    label={`Fin : ${moment(selectedTraning.end_date).format('DD MMM YYYY')}`}
                    sx={{ background: C.chipBg, color: C.textHi }}
                  />
                )}
              </Stack>

              <Stack direction="row" flexWrap="wrap" gap={1.5} mt={3}>
                <Button
                  size="large"
                  variant="contained"
                  startIcon={<SendIcon />}
                  onClick={() => handleJob(selectedTraning, 'Postuler')}
                  sx={{
                    background: C.accent,
                    fontWeight: 700,
                    textTransform: 'none',
                    boxShadow: '0 6px 18px rgba(27,117,208,0.35)',
                    '&:hover': { background: 'linear-gradient(135deg,#2a86e0 0%,#1f6f93 100%)' },
                  }}
                >
                  Postuler
                </Button>
                <Button
                  size="large"
                  variant="outlined"
                  startIcon={<BookmarkBorderIcon />}
                  onClick={() => handleJob(selectedTraning, 'Enregistrer')}
                  sx={{
                    color: C.textHi,
                    borderColor: 'rgba(193,218,241,0.35)',
                    textTransform: 'none',
                    fontWeight: 600,
                    '&:hover': { borderColor: '#74b7fd', background: 'rgba(27,117,208,0.08)' },
                  }}
                >
                  Enregistrer
                </Button>
                <Button
                  size="large"
                  variant="outlined"
                  startIcon={<PlaylistAddCheckIcon />}
                  onClick={() => setCreateTache(true)}
                  sx={{
                    color: C.textHi,
                    borderColor: 'rgba(193,218,241,0.35)',
                    textTransform: 'none',
                    fontWeight: 600,
                    '&:hover': { borderColor: '#74b7fd', background: 'rgba(27,117,208,0.08)' },
                  }}
                >
                  À faire
                </Button>
                <Button
                  size="large"
                  variant="outlined"
                  startIcon={<CalendarMonthIcon />}
                  onClick={() => setCreateEvent(true)}
                  sx={{
                    color: C.textHi,
                    borderColor: 'rgba(193,218,241,0.35)',
                    textTransform: 'none',
                    fontWeight: 600,
                    '&:hover': { borderColor: '#74b7fd', background: 'rgba(27,117,208,0.08)' },
                  }}
                >
                  Événement
                </Button>
                {selectedTraning.url && (
                  <Button
                    size="large"
                    variant="text"
                    endIcon={<OpenInNewIcon />}
                    href={selectedTraning.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{ color: '#74b7fd', textTransform: 'none', fontWeight: 600 }}
                  >
                    {selectedTraning.source ? selectedTraning.source : 'Source'}
                  </Button>
                )}
              </Stack>

              <Box
                sx={{
                  mt: 3,
                  p: 2.5,
                  background: C.card,
                  border: C.border,
                  borderRadius: 2.5,
                }}
              >
                <Typography sx={{ fontSize: 18, fontWeight: 700, color: C.textHi, mb: 1 }}>
                  À propos de la formation
                </Typography>
                <Typography sx={{ fontSize: 14, color: '#c1daf1', lineHeight: 1.7, whiteSpace: 'pre-line' }}>
                  {selectedTraning.description || '—'}
                </Typography>
              </Box>
            </Box>
          ) : (
            <Stack alignItems="center" justifyContent="center" spacing={1.5} sx={{ height: '100%', color: C.textLo }}>
              <SchoolIcon sx={{ fontSize: 64, opacity: 0.4 }} />
              <Typography sx={{ fontSize: 16, fontWeight: 600 }}>Offres de formation</Typography>
              <Typography sx={{ fontSize: 13, opacity: 0.8 }}>
                Sélectionne une formation à gauche pour voir le détail.
              </Typography>
            </Stack>
          )}
        </Box>
      </Box>
    </>
  )
}
